var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiditeLogo2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.6,3.8C16.4,6.2,1,37.6,1,37.6c0,0,1.5,0.1,3.9,0.1h3.9L9,37.5c0-0.1,2.6-5.3,5.7-11.7 c3.1-6.3,5.7-11.5,5.7-11.5c0,0,1.2,2.4,2.6,5.3l2.5,5.3l-3.3,0L19,25l-1.5,3.1c-0.8,1.7-1.5,3.2-1.5,3.2c0,0,2.8,0.1,6.2,0.1l6.2,0 l1.4,3c0.8,1.6,1.5,3,1.5,3.1l0.1,0.2h3.9c3.4,0,3.9,0,3.9-0.1c0,0-3.6-7.9-8.1-17.3L23.1,3h-2.6H18L17.6,3.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiditeLogo2);
export default __webpack_public_path__ + "static/media/aidite_logo_2.c075b58bcc06a9b47a5251f9ab6c2ef2.svg";
export { ForwardRef as ReactComponent };